<div class="container {{ OBJ_LNG_NAME }} insertEdit">
	<div class="dialog-header">
		<h1 mat-dialog-title>
			{{ (aktuell.id ? 'allgemein.bearbeiten' : 'allgemein.neu') | translate:locale.language:{ typ:
			OBJ_LNG_NAME+'.typ' | translate:locale.language } }}
			<mat-progress-bar *ngIf="dataService.isRequestRunning" color="primary" mode="indeterminate"></mat-progress-bar>
		</h1>
		<button class="close-button" mat-icon-button type="button" mat-dialog-close><mat-icon aria-label="Schließen">close</mat-icon></button>
	</div>
	<mat-dialog-content>

		<form #inserteditForm="ngForm" class="{{ OBJ_LNG_NAME }} inserteditForm">

			<p class="errors" *ngIf="dataService.fehler" [innerHTML]="dataService.fehler.messagehtml"></p>

			<mat-form-field class="full-width">
					<input matInput #name="ngModel" [(ngModel)]="aktuell.name" name="nameCtl"
								maxlength="100" [disabled]="dialogrunningajaxcall" required (input)="setSubmit(true)"/>
							<mat-label>{{ OBJ_LNG_NAME+'.titel' | translate:locale.language }}</mat-label>
							<mat-hint *ngIf="name.errors && (name.dirty || name.touched) && name.errors.required">{{ 'allgemein.validierung.nichtleer' | translate:locale.language:{ typ: OBJ_LNG_NAME+'.name' | translate:locale.language } }}</mat-hint>
							<mat-hint *ngIf="name.value" align="end">{{ name.value.length }} / 100</mat-hint>
			</mat-form-field>
					<mat-form-field class="full-width">
					<mat-select [(ngModel)]="aktuell.typ" (valueChange)="setSubmit(true)"
								name="typCtl"
								class="full-width" [disabled]="dialogrunningajaxcall" required>
						<mat-option *ngFor="let typ of aktuell.typen" [value]="typ">{{ typ }}</mat-option>
					</mat-select>
					<mat-label>{{ OBJ_LNG_NAME+'.fragebogen-typ' | translate:locale.language }}</mat-label>
					</mat-form-field>


				<div class="ngx-editor1">
					<div class="editor-title">
					   {{ OBJ_LNG_NAME+'.einleitungstext' | translate:locale.language }}
					</div>
					<ngx-wig name="einleitungstext" [(ngModel)]="aktuell.einleitungstext" (contentChange)="setSubmit(true)"></ngx-wig>
				</div>
					<mat-form-field class="full-width">
					<mat-select multiple="true" [compareWith]="compareMitId" [(ngModel)]="aktuell.lieferantenGruppen" name="lieferantenGruppenCtl"
								[formControl]="aktuell.selectCtl" (valueChange)="setSubmit(true)">
						<mat-option>
						<ngx-mat-select-search name="filter" [formControl]="aktuell.filterCtl"></ngx-mat-select-search>
						</mat-option>
						<mat-option *ngFor="let i of aktuell.filtered | dataPipeLieferantengruppe:aktuell.filterCtl" [value]="i">{{i.name}}</mat-option>
					</mat-select>
					<mat-label>{{ OBJ_LNG_NAME+'.lieferantengruppen' | translate:locale.language }}</mat-label>
					</mat-form-field>

				<mat-form-field>
					<input name="ablaufdatumCtl" matInput [matDatepicker]="ablaufdatumpicker" [min]="curDate()"
						   (click)="ablaufdatumpicker.open()" (dateChange)="setSubmit(true)"
						   [(ngModel)]="aktuell.ablaufdatum">
					<mat-datepicker-toggle matSuffix [for]="ablaufdatumpicker"></mat-datepicker-toggle>
					<mat-datepicker #ablaufdatumpicker></mat-datepicker>
					<mat-label>{{ OBJ_LNG_NAME+'.ablaufdatum' | translate:locale.language }}</mat-label>
				</mat-form-field>

			<div class="ngx-editor1">
			<div class="editor-title">
				   {{ OBJ_LNG_NAME+'.schlusstext' | translate:locale.language }}
			</div>
				 <ngx-wig name="schlusstext" [(ngModel)]="aktuell.schlusstext" (contentChange)="setSubmit(true)"></ngx-wig>
			</div>
		</form>
	</mat-dialog-content>

	<mat-dialog-actions align="end">

		<button mat-raised-button type="button" (click)="close()" [disabled]="dialogrunningajaxcall">{{ 'allgemein.abbrechen' | translate:locale.language }}</button>
		<button mat-raised-button type="submit" (click)="speichernAendern()" color="primary" [disabled]="!canSubmit || dialogrunningajaxcall">
			<mat-spinner *ngIf="dialogrunningajaxcall"></mat-spinner>
			{{ (dialogrunningajaxcall ? 'allgemein.daten.verarbeiten' : (neu ? 'allgemein.neu' : 'allgemein.speichern')) | translate:locale.language:{ typ: OBJ_LNG_NAME+'.typ' | translate:locale.language } }}
		</button>

	</mat-dialog-actions>
</div>

